import { useContext } from 'react';
import { LanguageContext } from '@/contexts/LanguageContext';
import { DEFAULT_LANGUAGE, translations, getTranslation } from '@/lib/i18n';

/**
 * Returns the LanguageContext when available.
 *
 * In rare cases (dev/HMR/cache), components may render before providers are resolved.
 * Instead of crashing the whole app, we provide a safe fallback that uses the
 * default language.
 */
export const useTranslation = () => {
  const context = useContext(LanguageContext);

  if (context) {
    return context;
  }

  const fallbackTranslations = translations[DEFAULT_LANGUAGE];

  return {
    language: DEFAULT_LANGUAGE,
    setLanguage: () => {
      // no-op fallback
    },
    translations: fallbackTranslations,
    t: (key: string, params?: Record<string, string | number>) =>
      getTranslation(fallbackTranslations, key, params),
  };
};
